import { render, staticRenderFns } from "./PowerbiAdminSidebar.vue?vue&type=template&id=55f8d486&scoped=true"
import script from "./PowerbiAdminSidebar.vue?vue&type=script&lang=js"
export * from "./PowerbiAdminSidebar.vue?vue&type=script&lang=js"
import style0 from "./PowerbiAdminSidebar.vue?vue&type=style&index=0&id=55f8d486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f8d486",
  null
  
)

export default component.exports